/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
            {
                internalType: "address",
                name: "_trustedRelayer",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract Mailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "moduleType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "trustedRelayer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TrustedRelayerIsm__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, _trustedRelayer, overrides) {
        return super.deploy(_mailbox, _trustedRelayer, overrides || {});
    }
    getDeployTransaction(_mailbox, _trustedRelayer, overrides) {
        return super.getDeployTransaction(_mailbox, _trustedRelayer, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=TrustedRelayerIsm__factory.js.map